module.exports = __webpack_public_path__ + "img/@img_jisike_02.dbbf7768.jpg";